<div class="container" *ngIf="tile">
  <app-clock-tile class="tile" *ngIf="type === 'Clock'" [tile]="tile"></app-clock-tile>
  <app-table-tile class="tile" *ngIf="type === 'Table'" [tile]="tile"></app-table-tile>
  <app-weather-tile class="tile" *ngIf="type === 'Weather'" [tile]="tile"></app-weather-tile>
  <app-list-tile class="tile" *ngIf="type === 'List'" [tile]="tile"></app-list-tile>
</div>
<div class="create" *ngIf="open && !tile">
  <mat-icon>add</mat-icon>
</div>